import type { QueryClient, QueryKey } from '@tanstack/react-query';
import { api } from './api';

/**
 * Datos que pide cada sección del menú al abrirse. Al pasar el mouse (o tocar) el ítem del menú
 * ya se piden, así al entrar la pantalla aparece completa en lugar de las barras de carga.
 * Las claves tienen que ser las mismas que usa cada pantalla.
 */
const ROUTES: Record<string, [QueryKey, string][]> = {
  '/venta': [
    [['pos', 'state'], '/pos/state'],
    [['pos', 'catalog'], '/pos/catalog'],
  ],
  '/caja': [
    [['cash', 'current'], '/cash/current'],
    [['pos', 'settings'], '/pos/settings'],
    [['cash', 'sessions'], '/cash/sessions'],
  ],
  '/clientes': [
    [['customers', 'list', '', 'all', false], '/customers?'],
    [['customers', 'list', '', 'debt', false], '/customers?filter=debt'],
  ],
  '/productos': [
    [['categories'], '/categories'],
    [['products', { includeInactive: false }], '/products'],
  ],
  '/precios': [
    [['categories'], '/categories'],
    [['products', {}], '/products'],
  ],
  '/proveedores': [[['suppliers'], '/suppliers']],
  '/desposte': [
    [['cutting', 'carcasses'], '/cutting/carcasses'],
    [['cutting', 'templates'], '/cutting/templates'],
  ],
  '/despostero': [[['workers'], '/workers']],
  '/produccion': [[['production', 'recipes'], '/production/recipes']],
  '/mermas': [[['waste', 'tacho'], '/waste/tacho']],
  '/empleados': [[['employees'], '/employees']],
  '/asistencia': [[['attendance', 'now'], '/attendance/now']],
  '/configuracion': [[['pos', 'settings'], '/pos/settings']],
  '/sucursales': [
    [['branches'], '/branches'],
    [['devices'], '/devices'],
  ],
  '/usuarios': [[['users'], '/users']],
};

const recent = new Map<string, number>();

export function prefetchRoute(qc: QueryClient, to: string): void {
  const list = ROUTES[to];
  if (!list) return;
  // Una vez cada 20 segundos por sección como mucho (el mouse pasa muchas veces por el menú).
  const now = Date.now();
  if ((recent.get(to) ?? 0) > now - 20_000) return;
  recent.set(to, now);
  for (const [queryKey, path] of list) {
    void qc.prefetchQuery({ queryKey, queryFn: () => api.get(path), staleTime: 20_000 });
  }
}
